import cx from 'classnames';
import {
    IS_SOLD_POLL_BUTTON_NO,
    IS_SOLD_POLL_BUTTON_YES,
    IS_SOLD_POLL_NOTE,
    IS_SOLD_POLL_TITLE,
} from 'mk/autogenerated/translations/IsSoldPoll.6c447d506134a66ad86e469d635d6c73'
import { formatPrice } from 'mk/bazaar/common/formatters';
import { capFirst } from 'mk/common/text';
import ProductCoverImageWithPopover from 'mk2/apps/bazaar/components/ProductCoverImageWithPopover';
import ProductQualityBadge from 'mk2/apps/bazaar/components/ProductQualityBadge';
import { isSoldPollNo, isSoldPollYes } from 'mk2/apps/bazaar/containers/IsSoldPoll/IsSoldPoll.actions';
import { getIsSoldPollState } from 'mk2/apps/bazaar/containers/IsSoldPoll/IsSoldPoll.selectors';
import { ProductEntity, ProductSchema } from 'mk2/apps/bazaar/schemas';
import { Btn, BtnType } from 'mk2/components/Btn';
import { Modal } from 'mk2/components/Modal';
import { Panel } from 'mk2/components/Panel';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import useEventCallback from 'mk2/hooks/useEventCallback';
import { AppState } from 'mk2/reducers';
import { getDenormalizedEntity } from 'mk2/selectors';
import React from 'react';
import { connect } from 'react-redux';
import styles from './IsSoldPoll.mscss';

interface OwnProps {
    className?: string;
}

interface StateProps {
    show: boolean;
    product: ProductEntity | null;
}

interface DispatchProps {
    onYes(productId: number);
    onNo(productId: number);
}

type Props = OwnProps & StateProps & DispatchProps;

const IsSoldPoll: React.FunctionComponent<Props> = ({ className, show, product, onYes, onNo }) => {
    const onYesCallback = useEventCallback(() => {
        onYes(product.id);
    }, [product]);

    const onNoCallback = useEventCallback(() => {
        onNo(product.id);
    }, [product]);

    return (
        <Modal show={show} className={cx(styles.IsSoldPoll, className)} backdrop="static">
            <Panel className={styles.IsSoldPoll__container}>
                <h1 className={styles.IsSoldPoll__title}>{IS_SOLD_POLL_TITLE}</h1>
                <div className={styles.IsSoldPoll__product}>
                    {product && (
                        <>
                            <ProductCoverImageWithPopover
                                product={product}
                                className={styles.IsSoldPoll__product__image}
                                size={50}
                            />
                            <div className={styles.IsSoldPoll__product__title}>
                                <span className={styles.IsSoldPoll__product__title__title}>
                                    {capFirst(product.title)}
                                </span>{' '}
                                - {formatPrice(product.price)}
                                <br />
                                <ProductQualityBadge
                                    className={styles.IsSoldPoll__product__title__qualityBadge}
                                    quality={product.quality}
                                />
                            </div>
                        </>
                    )}
                </div>
                <div className={styles.IsSoldPoll__buttons}>
                    <Btn
                        className={styles.IsSoldPoll__buttons__button}
                        type={BtnType.Blue}
                        label={IS_SOLD_POLL_BUTTON_YES}
                        onClick={onYesCallback}
                    />{' '}
                    <Btn
                        className={styles.IsSoldPoll__buttons__button}
                        type={BtnType.BlueOutline}
                        label={
                            <>
                                {IS_SOLD_POLL_BUTTON_NO}
                                <sup>*</sup>
                            </>
                        }
                        onClick={onNoCallback}
                    />
                </div>
                <div className={styles.IsSoldPoll__note}>
                    <sup>*</sup> {IS_SOLD_POLL_NOTE}
                </div>
            </Panel>
        </Modal>
    );
};

IsSoldPoll.displayName = 'IsSoldPoll';

export { IsSoldPoll };

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    const substate = getIsSoldPollState(state);

    return {
        show: substate.show,
        product: getDenormalizedEntity<ProductEntity>(state, ProductSchema, substate.productId),
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onYes: isSoldPollYes,
    onNo: isSoldPollNo,
};

export default connect(mapStateToProps, mapDispatchToProps)(IsSoldPoll);
